export const templateComps = {
  confirmModal: {
    cancel: "Annulla",
    delete: "Elimina",
  },
  channexIncident: {
    kicker: "Avviso importante",
    brandTitle: "Incidente esterno",
    closeLabel: "Chiudi avviso",
    subtitle:
      "Stiamo monitorando la situazione e verificheremo la sincronizzazione una volta ripristinato il servizio.",
    title:
      "Incidente generale nella connessione con Booking / Airbnb / channel manager esterno",
    lead: "Ciao, stiamo rilevando un incidente generale con il nostro fornitore esterno di sincronizzazione OTA.",
    text: "Questo incidente riguarda la loro API e potrebbe ritardare la sincronizzazione di prenotazioni, disponibilità e chiusure delle date.",
    note: "Non appena la connessione sarà ripristinata, verificheremo la sincronizzazione dei dati per controllare prenotazioni, disponibilità e chiusure delle date.",
    textLast:
      "Noi di WA Checkin verificheremo la sincronizzazione una volta che il servizio sarà di nuovo operativo.",
    button: "Ho capito",
  },
  notificationsNav: {
    title: "Notifiche",
    recent: "recenti",
    emptyTitle: "Nessuna notifica",
    emptyText:
      "Quando succede qualcosa di importante con le tue prenotazioni, comparirà qui.",
    seeAll: "Vedi tutte le notifiche",
    meta: {
      t1: { status: "Nuova", category: "prenotazione" },
      t2: { status: "Aggiornata", category: "prenotazione" },
      t3: { status: "Annullata", category: "prenotazione" },
      t4: { status: "Completato", category: "check-in" },
      t5: { status: "Richiesto", category: "servizio" },
      t6: { status: "Ricevuta", category: "richiesta" },
      t7: { status: "Approvata", category: "richiesta" },
      t8: { status: "Rifiutata", category: "richiesta" },
      t9: { status: "Confermato", category: "pagamento" },
      t10: { status: "In attesa di pagamento", category: "pagamento in sospeso" },
      t11: { status: "Assegna camera", category: "prenotazione" },
      t12: { status: "Invio non riuscito", category: "check-in" },
      t13: { status: "Non inviato", category: "registrazione viaggiatore" },
      t15: { status: "Attivo", category: "abbonamento" },
      default: { status: "Avviso", category: "sistema" },
    },
    typeLabel: {
      t1: "NUOVA PRENOTAZIONE",
      t2: "PRENOTAZIONE AGGIORNATA",
      t3: "PRENOTAZIONE ANNULLATA",
      t4: "CHECK-IN",
      t5: "SERVIZIO",
      t6: "RICHIESTA",
      t7: "RICHIESTA APPROVATA",
      t8: "RICHIESTA RIFIUTATA",
      t10: "IN ATTESA DI PAGAMENTO",
      t11: "ASSEGNA CAMERA",
      t12: "INVIO NON RIUSCITO",
      t13: "REGISTRAZIONE VIAGGIATORE",
      t15: "ABBONAMENTO ATTIVO",
      default: "NOTIFICA",
    },
  },
};
